import React from "react";
import { FormattedMessage } from "react-intl";

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th
          className="sort"
          data-sort="name"
          scope="col"
          onClick={() => props.applySort("name")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.name" />
        </th>
        <th
          className="sort"
          data-sort="neo_id"
          scope="col"
          onClick={() => props.applySort("neo_id")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.neo_id" />
        </th>
        <th
          className="sort"
          data-sort="cui"
          scope="col"
          onClick={() => props.applySort("cui")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.cui" />
        </th>
        <th
          className="sort"
          data-sort="registry_no"
          scope="col"
          onClick={() => props.applySort("registry_no")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.registry_no" />
        </th>
        <th
          className="sort"
          data-sort="user_id"
          scope="col"
          onClick={() => props.applySort("user_id")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.user_id" />
        </th>
        <th
          className="sort"
          data-sort="phone"
          scope="col"
          onClick={() => props.applySort("phone")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.phone" />
        </th>
        <th
          className="sort"
          data-sort="city"
          scope="col"
          onClick={() => props.applySort("city")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.city" />
        </th>
        <th
          className="sort"
          data-sort="county"
          scope="col"
          onClick={() => props.applySort("county")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.county" />
        </th>
        <th
          className="sort"
          data-sort="country"
          scope="col"
          onClick={() => props.applySort("country")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.country" />
        </th>
        <th
          className="sort"
          data-sort="status"
          scope="col"
          onClick={() => props.applySort("status")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.status" />
        </th>
        <th
          className="sort"
          data-sort="api_key_status"
          scope="col"
          onClick={() => props.applySort("api_key_status")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.api_key_status" />
        </th>
        <th
          className="sort"
          data-sort="archiveServiceSetting.status"
          scope="col"
          onClick={() => props.applySort("archiveServiceSetting.status")}
        >
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.archive_service_settings" />
        </th>
        <th scope="col">
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.kiosk_access" />
        </th>
        <th scope="row" className="w-10">
          <FormattedMessage id="components.pages.organizations.organizationsTable.table.actions" />
        </th>
      </tr>
    </thead>
  );
}

export { TableHead };
